import { render, staticRenderFns } from "./TeacherEditor.vue?vue&type=template&id=a08931ba"
import script from "./TeacherEditor.vue?vue&type=script&lang=js"
export * from "./TeacherEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports